import { useState } from 'react'
import { Box, Typography } from '@mui/material'
import HomeEventRow from '../home/HomeEventRow'
import { sectionHeadingSx } from '../../theme/mobileLayout'

export default function EventRelatedEvents({ events }) {
  const [hoveredSlug, setHoveredSlug] = useState(null)

  if (!events.length) return null

  return (
    <Box
      component="section"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: { xs: 5, md: '80px' },
        width: '100%',
      }}
    >
      <Typography component="h2" sx={sectionHeadingSx}>
        Upcoming Events
      </Typography>

      <Box
        sx={{ display: 'flex', flexDirection: 'column', gap: '44px' }}
        onMouseLeave={() => setHoveredSlug(null)}
      >
        {events.flatMap((event, index) => {
          const items = [
            <HomeEventRow
              key={event.slug}
              {...event}
              to={`/events/${event.slug}`}
              isImageActive={hoveredSlug === event.slug}
              onRowHover={() => setHoveredSlug(event.slug)}
            />,
          ]
          if (index < events.length - 1) {
            items.push(
              <Box
                key={`${event.slug}-divider`}
                sx={{ borderBottom: '1px solid rgba(0,0,0,0.12)' }}
              />,
            )
          }
          return items
        })}
      </Box>
    </Box>
  )
}
